import { IFlexLayout } from 'core-components/sitebuilder/models/flexGrid/IFlexLayout'

export const getAllWrappersInPage = (pageId: string, flexSettings: IFlexLayout, type?: string) => {
  const flSettings = structuredClone(flexSettings)
  let allWrappersInPage = {}
  for (const i in flSettings) {
    if (i.indexOf(pageId) === 0) {
      const index = i.replace(`${pageId}-`, '')
      allWrappersInPage = {
        ...allWrappersInPage,
        [type === 'onlyArea' ? index : i]: structuredClone(flexSettings[i]),
      }
    }
  }
  return allWrappersInPage
}
